import { Button } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { AlertSeverity, useLoading } from "../../hooks/useLoading";
import { NPOWithActivities } from "../../models/Npo";
import { OrgUnit } from "../../models/OrgUnit";
import { OrgType, useAPI } from "../../util/useAPI";

export default function JoinOrgButton({ orgType, refreshPage, orgUnit, npo, labelOverride }:{
  orgType: OrgType,
  refreshPage: () => void,
  orgUnit?: OrgUnit,
  npo?: NPOWithActivities,
  labelOverride?: string
}) {
  const FieldDayAPI = useAPI()
  const { loadStart, loadEnd, setAlert } = useLoading()
  const { refreshUserProfile } = useAuth()

  if(!orgUnit && !npo) return null

  const orgId = orgType === 'orgunit' ? orgUnit?.id : npo?.id
  const joinTypeLabel = orgType === 'orgunit' ? "Join Team" : "Join nonprofit"

  const handleSubmit = () => {
    if(!orgId) {
      setAlert(AlertSeverity.ERROR, 'Error creating membership. Valid org id required')
      return
    }
    loadStart(true)
    FieldDayAPI.createMembership(orgType, orgId).then((_resp) => {
      setAlert(AlertSeverity.SUCCESS, `New membership created for ${orgUnit ? orgUnit.name : npo?.name}`)
      refreshUserProfile()
      refreshPage()
    }).catch((err) => {
      const errMsg = err.response?.data?.message || `${err}`
      setAlert(AlertSeverity.ERROR, errMsg)
    }).finally(loadEnd)
  }

  return (
    <Button variant='contained' onClick={handleSubmit}>
      {labelOverride ?? joinTypeLabel}
    </Button>
  )
}
